module.exports = __webpack_public_path__ + "static/img/contact-code.0e8033b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/contact-code.png
// module id = TYLA
// module chunks = 0